// BookingStep3.jsx – Optional Services + Guest Info
import { useBooking } from '../context/BookingContext';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

export default function BookingStep3() {
  const { bookingData, setBookingData } = useBooking();
  const navigate = useNavigate();

  const [services, setServices] = useState({
    breakfast: bookingData.optionalServices?.breakfast || false,
    earlyCheckIn: bookingData.optionalServices?.earlyCheckIn || false,
    pets: bookingData.optionalServices?.pets || false,
  });

  const [guestInfo, setGuestInfo] = useState({
    fullName: bookingData.guestInfo?.fullName || '',
    email: bookingData.guestInfo?.email || '',
    phone: bookingData.guestInfo?.phone || '',
    address: bookingData.guestInfo?.address || '',
  });

  const [error, setError] = useState('');

  const handleServiceChange = (e) => {
    setServices({ ...services, [e.target.name]: e.target.checked });
  };

  const handleGuestChange = (e) => {
    setGuestInfo({ ...guestInfo, [e.target.name]: e.target.value });
  };

  const handleNext = () => {
    if (!guestInfo.fullName || !guestInfo.email || !guestInfo.phone || !guestInfo.address) {
      setError('Please fill in all contact information before continuing.');
      return;
    }


    setBookingData({
      ...bookingData,
      optionalServices: services,
      guestInfo: guestInfo,
    });

    navigate('/booking/step4');
  };

  return (
    <div className="step-container">
      <h2>Step 3: Optional Services</h2>

      {/* Progress Bar */}
      <div className="progress-bar">
        <div className="progress-fill" style={{ width: '60%' }}></div>
      </div>

      {/* Optional Services */}
      
      {/* <label>
        <input
          type="checkbox"
          name="breakfast"
          checked={services.breakfast}
          onChange={handleServiceChange}
        />
        Breakfast
      </label> */}

      <label>
        <input
          type="checkbox"
          name="earlyCheckIn"
          checked={services.earlyCheckIn}
          onChange={handleServiceChange}
        />
        Early Check-In
      </label>

      <label>
        <input
          type="checkbox"
          name="pets"
          checked={services.pets}
          onChange={handleServiceChange}
        />
        Pets Allowed
      </label>

      {/* Guest Info Section */}
      <div className="guest-info-section">
        <h2>Guest Info & Confirm</h2>
        <input
          name="fullName"
          placeholder="Full Name"
          value={guestInfo.fullName}
          onChange={handleGuestChange}
        />
        <input
          name="email"
          placeholder="Email"
          value={guestInfo.email}
          onChange={handleGuestChange}
        />
        <input
          name="phone"
          placeholder="Phone"
          value={guestInfo.phone}
          onChange={handleGuestChange}
        />
        <input
          name="address"
          placeholder="Address"
          value={guestInfo.address}
          onChange={handleGuestChange}
        />
      </div>

      {/* Show error if any field missing */}
      {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}

      <button onClick={handleNext}>Next</button>
    </div>
  );
}
